import { useQuery } from "@tanstack/react-query";
import { affordableHousingComApi } from "api/affordableHousingCom";
import {
  AH_MONTHLY_LEAD_LIMIT,
  QUERY_AH_STATUS
} from "views/settings-integration/integrations/affordable-housing-com/constants";

export interface AhLeadUsage {
  count: number;
  limit: number;
  isLimitReached: boolean;
  resetsOn?: string;
}

// The API owns the count (AffordableHousing.com lead source, calendar month in
// Central time). Returns null until it loads so the tracker never flashes 0.
export const useAhLeadUsage = ({
  enabled = true
}: { enabled?: boolean } = {}): AhLeadUsage | null => {
  const { data } = useQuery({
    queryKey: QUERY_AH_STATUS,
    queryFn: affordableHousingComApi.getStatus,
    enabled
  });

  if (!data) return null;

  const count = data.leads_this_month ?? 0;
  const limit = data.lead_limit ?? AH_MONTHLY_LEAD_LIMIT;

  return {
    count,
    limit,
    isLimitReached: data.limit_reached ?? count >= limit,
    resetsOn: data.resets_on
  };
};
